export default __webpack_public_path__ + "static/media/ES.a72e75b8.png";